module.exports = __webpack_public_path__ + "static/media/ptmlogo.637ddebd.jpg";